import { ReactNode } from 'react'
import { GroupBase, ValueContainerProps } from 'react-select'

import { BodyVariant, SizeOptions } from '../../../../types/types'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { SelectOption } from '../../AstraSelect'

const SizeStylesParagraph: Record<SizeOptions, BodyVariant> = {
    small: 'body-small',
    medium: 'body',
    large: 'body',
}

export type AstraMultiSelectTextValueContainerProps<T> = ValueContainerProps<SelectOption<T>, true, GroupBase<SelectOption<T>>> & {
    selectedOptions: SelectOption<T>[]
    placeholder?: ReactNode
    size: SizeOptions
    /** Keep react-select's (hidden) focus target mounted so the menu still closes on click-away in inline mode. */
    keepFocusTarget?: boolean
}

export const AstraMultiSelectTextValueContainer = <T,>({
    selectedOptions,
    placeholder,
    size,
    keepFocusTarget,
    children,
}: AstraMultiSelectTextValueContainerProps<T>) => {
    const hasSelection = selectedOptions.length > 0
    const text = hasSelection ? selectedOptions.map(option => option.label).join(', ') : placeholder

    return (
        <div className="flex w-full min-w-0 items-center overflow-hidden !pl-0">
            <AstraParagraph variant={SizeStylesParagraph[size]} className={`min-w-0 flex-1 truncate ${hasSelection ? '' : 'text-subtle'}`}>
                {text}
            </AstraParagraph>
            {keepFocusTarget && <span className="sr-only">{children}</span>}
        </div>
    )
}
